<template>
    <div class="nk-app-root">
        <!-- main @s -->
        <div class="nk-main ">
            <!-- wrap @s -->
            <div class="nk-wrap nk-wrap-nosidebar">
                <!-- content @s -->
                <div class="nk-content ">
                    <div class="nk-split nk-split-page nk-split-lg">
                        <div class="nk-split-content nk-block-area nk-block-area-column nk-auth-container bg-white">
                            <div class="absolute-top-right d-lg-none p-3 p-sm-5">
                                <a href="javascript:void(0)" class="toggle btn-white btn btn-icon btn-light" data-target="athPromo"><em class="icon ni ni-info"></em></a>
                            </div>
                            <div class="nk-block nk-block-middle nk-auth-body">
                                <div class="brand-logo pb-5">
                                    <a href="javascript:void(0)" class="logo-link">
                                        <img class="logo-light logo-img logo-img-lg" src="/images/logo.png" alt="logo">
                                        <img class="logo-dark logo-img logo-img-lg" src="/images/logo.png" alt="logo-dark">
                                    </a>
                                </div>
                                <div class="nk-block-head">
                                    <div class="nk-block-head-content">
                                        <h5 class="nk-block-title">Sign-In</h5>

                                    </div>
                                </div><!-- .nk-block-head -->

                                <div class="form-group">
                                    <div class="form-label-group">
                                        <label class="form-label" for="email-address">Email or Username</label>
                                        <!--<a class="link link-primary link-sm" tabindex="-1" href="#">Need Help?</a>-->
                                    </div>
                                    <div class="form-control-wrap">
                                        <input v-model="login.email" autocomplete="off"  type="text" class="form-control form-control-lg" id="email-address" placeholder="Enter your email address or username">
                                    </div>
                                </div><!-- .form-group -->
                                <div class="form-group">
                                    <div class="form-label-group">
                                        <label class="form-label" for="password">Password</label>
                                    </div>
                                    <div class="form-control-wrap">
                                        <a href="javascript:void(0)" tabindex="-1" v-if="showPassword==false" class="form-icon form-icon-right lg" v-on:click="showPasswords()">
                                            <em :key="render" class="passcode-icon icon-show icon ni ni-eye"></em>
                                        </a>
                                        <a href="javascript:void(0)" tabindex="-1" v-if="showPassword==true" class="form-icon form-icon-right lg" v-on:click="showPasswords()">
                                            <em :key="render" class="passcode-icon icon-show icon ni ni-eye-off"></em>
                                        </a>
                                        <input v-model="login.password" autocomplete="off"  v-bind:type="showPassword==false? 'password' : 'text'" class="form-control form-control-lg" placeholder="Enter your password">

                                    </div>
                                    <div class="form-label-group mt-2">
                                        <label class="link link-primary link-sm"></label>
                                        <a v-on:click="show=true" class="link link-primary link-sm" href="javascript:void(0)">Forgot Password?</a>

                                    </div>
                                </div><!-- .form-group -->
                                <div class="form-group">
                                    <div class="nk-block-des">
                                        <p>{{ customError }}</p>
                                    </div>
                                    <button v-bind:disabled="$v.$invalid" v-on:click="userlogin" class="btn btn-lg btn-primary btn-block">Sign in</button>

                                </div>

                                <div class="form-note-s2 pt-4">
                                    New on our platform? <a href="javascript:void(0)" v-on:click="GoToSignup()">Create an account</a>
                                </div>

                            </div><!-- .nk-block -->
                            <div class="nk-block nk-auth-footer">
                                <div class="nk-block-between">
                                    <ul class="nav nav-sm">
                                        <li class="nav-item">
                                            <a v-on:click="GoToTerms()" class="nav-link" href="javascript:void(0)">Terms & Condition</a>
                                        </li>
                                        <li class="nav-item">
                                            <a v-on:click="GoToPrivacy()" class="nav-link" href="javascript:void(0)">Privacy Policy</a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" href="mailto:support@blackstonecapitals.com">Help</a>
                                        </li>
                                        <li class="nav-item dropup">
                                            <a class="dropdown-toggle dropdown-indicator has-indicator nav-link" data-bs-toggle="dropdown" data-offset="0,10"><small>English</small></a>
                                            <div class="dropdown-menu dropdown-menu-sm dropdown-menu-end">
                                                <ul class="language-list">
                                                    <li>
                                                        <a href="javascript:void(0)" class="language-item">
                                                            <img src="/images/flags/english.png" alt="" class="language-flag">
                                                            <span class="language-name">English</span>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="javascript:void(0)" class="language-item">
                                                            <img src="/images/flags/turkey.png" alt="" class="language-flag">
                                                            <span class="language-name">T�rk�e</span>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                    </ul><!-- .nav -->
                                </div>
                                <div class="mt-3">
                                    <p>&copy; 2022 Black Stone Capitals. All Rights Reserved.</p>
                                </div>
                            </div><!-- .nk-block -->
                        </div><!-- .nk-split-content -->
                        <div class="nk-split-content nk-split-stretch bg-lighter d-flex toggle-break-lg toggle-slide toggle-slide-right" data-toggle-body="true" data-content="athPromo" data-toggle-screen="lg" data-toggle-overlay="true">
                            <div class="slider-wrap w-100 w-max-550px p-3 p-sm-5 m-auto">
                                <div class="slider-init">
                                    <div class="slider-item">
                                        <div class="nk-feature nk-feature-center">
                                            <div class="nk-feature-img">
                                                <img class="round" src="/images/login.svg" srcset="/images/login.svg" alt="">
                                            </div>
                                            <!--<div class="nk-feature-content py-4 p-sm-4">
                                                <h4>Black Stone Capitals</h4>
                                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s</p>
                                            </div>-->
                                        </div>
                                    </div><!-- .slider-item -->

                                </div><!-- .slider-init -->
                                <div class="slider-dots"></div>
                                <div class="slider-arrows"></div>
                            </div><!-- .slider-wrap -->
                        </div><!-- .nk-split-content -->
                    </div><!-- .nk-split -->
                </div>
                <!-- wrap @e -->
            </div>
            <!-- content @e -->
        </div>
        <!-- main @e -->
        <forgot-password :show="show" v-if="show" @close="show=false" />

        <loading :name="loading" :active.sync="loading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
    </div>
    <!-- app-root @e -->

</template>
<script>
    import { required } from 'vuelidate/lib/validators';
    import Loading from 'vue-loading-overlay';
    import "vue-loading-overlay/dist/vue-loading.css";

    export default {
        components: {
            Loading
        },
        data() {
            return {
                render: 0,
                showPassword: false,
                loading: false,
                show: false,
                login: {
                    email: '',
                    password: '',
                    rememberMe: true
                },
                error: '',
                customError: ''
            }
        },
        validations: {
            login:
            {
                email:
                {
                    required
                },
                password:
                {
                    required,
                    strongPassword(password) {
                        return /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/.test(password);
                    }
                },
            }
        },

        methods: {
            showPasswords: function () {

                this.showPassword = this.showPassword == true ? false : true;
                this.render++;
            },

            GoToTerms: function () {
                this.$router.push('/TermsAndCondition')
            },

            GoToPrivacy: function () {
                this.$router.push('/TermsAndCondition')
            },

            GoToSignup: function () {
                this.$router.push('/SignUp')
            },

            userlogin: function () {

                var root = this;
                this.loading = true;

                var url = '/account/login';
                this.$https.post(url, this.login).then(function (response) {
                    if (response.data != null) {

                        if (response.data.companyId == "00000000-0000-0000-0000-000000000000") {
                            if (response.data.errorMessage == 'Your Email is not verified !') {
                                root.$swal({
                                    title: "Oops...",
                                    text: response.data.errorMessage,
                                    type: "error",
                                    icon: "error",
                                    showCancelButton: true,
                                    confirmButtonColor: "#DD6B55",
                                    confirmButtonText: "Resend Email?",
                                    closeOnConfirm: false,
                                    closeOnCancel: false
                                }).then(function (result) {
                                    if (result.isConfirmed) {
                                        root.SendResendEmailVerification(root.login.email);
                                    }
                                });

                                root.loading = false;
                            }
                            else {
                                root.$swal.fire(
                                    {
                                        icon: 'error',
                                        title: 'Oops...',
                                        text: response.data.errorMessage,
                                    });
                                root.loading = false;
                            }

                        }
                        else {
                            root.$session.start();

                            root.$swal.fire(
                                {
                                    toast: true,
                                    position: 'top-end',
                                    showConfirmButton: false,
                                    timer: 1500,
                                    timerProgressBar: true,
                                    icon: 'success',
                                    title: "<h5 style='color: #000000;'>Logged in Successfully</h5>",
                                    didOpen: (toast) => {
                                        toast.addEventListener('mouseenter', root.$swal.stopTimer)
                                        toast.addEventListener('mouseleave', root.$swal.resumeTimer)
                                    }
                                });
                            root.loading = false;
                            

                            localStorage.setItem('token', response.data.token);
                            localStorage.setItem('UserName', response.data.userName);
                            localStorage.setItem('UserEmail', response.data.userEmail);
                            localStorage.setItem('RoleName', response.data.roleName);
                            localStorage.setItem('UserID', response.data.userId);                            
                            localStorage.setItem('FullName', response.data.fullName);
                            localStorage.setItem('FirstName', response.data.firstName);
                            localStorage.setItem('LastName', response.data.lastName);
                            localStorage.setItem('Verified', response.data.verified);
                            localStorage.setItem('ReferralId', response.data.referralId);
                            localStorage.setItem('PackagePlanAmount', response.data.packagePlanAmount);
                            localStorage.setItem('ActiveBasicPackage', response.data.activeBasicPackage);
                            root.SendEmailVerification();
                            
                            if (response.data.roleName == 'Customer') {
                                window.location.href = "/Dashboard";
                            }
                            else {
                                /*root.$router.push('/AdminDashboard');*/
                                window.location.href = "/AdminDashboard";
                            }
                        }
                    }

                }).catch(error => {

                    console.log(error)
                    root.$swal.fire(
                        {
                            icon: 'error',
                            title: 'Oops...',
                            text: error,
                        });
                    root.errored = true
                })
                    .finally(() => root.loading = false)
            },
            SendResendEmailVerification: function (email) {
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                this.$https.get('/account/ResendSendEmailVerification?email=' + email, { headers: { "Authorization": `Bearer ${token}` } });

            },

            SendEmailVerification: function () {
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                this.$https.get('/account/SendLoginEmail?id=' + localStorage.getItem('UserID'), { headers: { "Authorization": `Bearer ${token}` } });

            },
        },
        beforeCreate: function () {

            if (this.$session.exists()) {

                if (localStorage.getItem('RoleName') == 'Customer') {
                    window.location.href = "/Dashboard";
                }
                else {
                    /*this.$router.push('/AdminDashboard');*/
                    window.location.href = "/AdminDashboard";
                }
            }
        },

    }
</script>
